/**
 * Converts UIMessage array (with parts) to plain { role, content } format.
 *
 * Used by both useChat transport (signing) and token counting.
 *
 * @param {Array} messages - UIMessage objects from useChat
 * @returns {Array<{role: string, content: string}>}
 */
const messagesToPlain = (messages) =>
  messages.flatMap((msg) =>
    msg.parts
      ? msg.parts
          .filter((part) => part.type === "text")
          .map((part) => ({ role: msg.role, content: part.text }))
      : [{ role: msg.role, content: msg.content || "" }],
  );

export default messagesToPlain;
